import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import validator from "validator";

import { apiHeader, BaseURL, imageUrl } from "../../config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { getRealPhoneNumber } from "../../utils/functions";
import { Button } from "../../Component/Button/Button";
import { Input } from "../../Component/Input/Input";
import CustomPhoneInput from "../../Component/CustomPhoneInput";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./SignUpModal.module.css";
import { useLogo } from "../../contexts/LogoContext";

const SignUpModal = ({ show, setShow, showLogin }) => {
  const { logo } = useLogo();
  const fcmToken = useSelector((state) => state?.authReducer?.fcmToken);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const headers = apiHeader();

  const handleSignUp = async () => {
    const url = BaseURL("auth/signup");
    let params = {
      firstName,
      lastName,
      email,
      password,
      passwordConfirm: confirmPassword,
      contact: contact ? `+1${getRealPhoneNumber(contact)}` : "",
    };
    if (
      !validator.isMobilePhone(params["contact"], "en-US", { strictMode: true })
    ) {
      return toast.warn("Your mobile number is not valid.");
    }
    if (!validator.isEmail(params["email"])) {
      return toast.warn("Your Email is not valid.");
    }
    if (params["password"]?.length < 8) {
      return toast.error("Password must contain min 8 characters");
    }
    if (password !== confirmPassword) {
      return toast.error("Password does not match");
    }
    for (let key in params) {
      if (params[key] === "" || params[key] === undefined) {
        return toast.error("Please fill all the required fields!");
      }
    }
    params = {
      ...params,
      fcmToken,
    };
    setLoading(true);
    const response = await Post(url, params, headers);
    if (response !== undefined) {
      //      await dispatch(saveLoginUserData(response?.data));
      toast.success(
        "Thank you for signing up, check your email to activate your account."
      );
      setShow(false);
    }

    setLoading(false);
  };

  return (
    <>
      <style>{`
    .modal-content{
      border-radius:16px !important;
    }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        modalClass={[classes.signupModal, "customScroll"].join(" ")}
        width={"752px"}
      >
        <Row>
          <Col md={12}>
            <div className={`modal_header_logo`} style={{ justifyContent: 'left', marginBottom: 0 }}>
              <img src={`${imageUrl}${logo}`} alt="Logo" width={150} />
            </div>
          </Col>

          <Col md={12}>
            <div className={classes.SignupText}>
              <h3>Create Account</h3>
            </div>
          </Col>
          <Col md={12}>
            <div className={[classes.inputCol]}>
              <Input
                placeholder="First Name"
                onEnterClick={handleSignUp}
                value={firstName}
                setter={setFirstName}
                autocomplete={"off"}
              />
            </div>
            <div className={[classes.inputCol]}>
              <Input
                placeholder="Last Name"
                value={lastName}
                onEnterClick={handleSignUp}
                setter={setLastName}
                autocomplete={"off"}
              />
            </div>
            <div className={[classes.inputCol]}>
              <Input
                placeholder="Email"
                type="email"
                onEnterClick={handleSignUp}
                value={email}
                setter={setEmail}
                autocomplete={"off"}
              />
            </div>

            <div className={[classes.inputCol]}>
              <CustomPhoneInput
                value={contact}
                setter={setContact}
                label={false}
                autocomplete={"off"}
              />
            </div>
            <div className={[classes.inputCol]}>
              <Input
                placeholder="Password"
                value={password}
                onEnterClick={handleSignUp}
                setter={setPassword}
                type="password"
                autocomplete={"off"}
              />
            </div>
            <div className={[classes.inputCol]}>
              <Input
                placeholder="Confirm Password"
                value={confirmPassword}
                setter={setConfirmPassword}
                onEnterClick={handleSignUp}
                type="password"
                autocomplete={"off"}
              />
            </div>

            <Button
              className={classes.SignupBtn}
              label={loading ? "submitting..." : "Create Account"}
              onClick={handleSignUp}
              disabled={loading}
            />
            <div
              onClick={() => {
                setShow(false);
                showLogin(true);
              }}
              className={[classes.SignUpDiv]}
            >
              You already have an account with us?&nbsp;
              <span className={[classes.SignUpText]}>Sign In</span>
            </div>
          </Col>
        </Row>
      </ModalSkeleton>
    </>
  );
};

export default SignUpModal;
